import Axios from "axios";
import Apis from "../../config/Apis";
import { hideLoading, showAlert, showLoading } from "../Actions/GeneralActions";
import { headers } from "../../utills";
import {
  createWellWishing,
  eventDatailsGuest,
  getGuestRsvpDetails,
  guestUpcomingEvents,
  updateGuestRsvpEvent,
} from "../Actions/GuestActions";

export const GuestMiddleware = {
  guestUpcomingEvents: (search = null) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          // dispatch(showLoading());
          let formData = new FormData();
          if (search) formData.append("name", search);
          const response = await Axios.post(
            Apis.guestUpcomingEvents,
            search ? formData : {},
            await headers.config()
          );

          if (response?.status == 200) {
            resolve(true);
            dispatch(guestUpcomingEvents(response?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "error",
            })
          );
        }
      });
    };
  },

  getGuestEventDetails: (event_id) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const response = await Axios.get(
            Apis.guestEventDetail(event_id),
            await headers.config()
          );

          if (response?.status == 200) {
            resolve(true);
            dispatch(eventDatailsGuest(response?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "error",
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  createWeddingWall: (temp = null) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formData = new FormData();
          formData.append("event_id", temp.event_id);
          formData.append("notes", temp.notes);
          const response = await Axios.post(
            Apis.createWeddingWall,
            formData,
            await headers.config()
          );
          if (response?.status == 200) {
            resolve(temp.notes);
            dispatch(createWellWishing(response?.data?.data?.well_wish));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "error",
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  guestRsvpDetails: (temp = null) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formData = new FormData();
          formData.append("event_id", temp);
          const response = await Axios.post(
            Apis.getGuestRsvpDetails,
            formData,
            await headers.config()
          );
          if (response?.status == 200) {
            resolve(true);
            dispatch(getGuestRsvpDetails(response?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "error",
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  submitRsvp: (RSVP, EventDetails) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", EventDetails?.id);

          for (const [i, element] of RSVP?.atendeeArr?.entries()) {
            if (element?.selectMeal?.id)
              formData.append(`attendees[${i}][id]`, element?.selectMeal?.id);
            if (element?.name)
              formData.append(`attendees[${i}][name]`, element?.name);
          }

          for (const [i, element] of RSVP?.tidbits.entries()) {
            if (element?.id) formData.append(`tidbits[${i}][id]`, element?.id);
            if (element?.answer)
              formData.append(`tidbits[${i}][answer]`, element?.answer);
          }
          const data = await Axios.post(
            Apis.guestSubmitRsvp,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(
              eventDatailsGuest({ ...EventDetails, is_rsvp_submitted: true })
            );
            dispatch(
              showAlert({
                type: "Success",
                message: data?.data?.message,
              })
            );
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Submit Rsvp",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
};
